import React, { ReactElement } from 'react';

import { RendererProps } from '../../models';
import FullPad from '../../../../../../components/FullPad';
import { getPx } from '../../helpers';

function InputPad({ entity }: RendererProps): ReactElement {
  const panelB = entity.panelDims.b ?? 0;
  const panelM = entity.panelDims.m ?? 0;
  const panelMeas = {
    width: getPx(entity.panelDims.w),
    height: getPx(entity.panelDims.h),
    border: getPx(panelB),
    margin: getPx(panelM),
    space: getPx(2 * panelB + 2 * panelM),
  };

  // Styling
  const fullPadStyle = {
    zIndex: 10,
  };

  return (
    <FullPad
      callback={entity.callback}
      panelMeas={panelMeas}
      inputMode={entity.inputMode}
      whichPadLabels={entity.whichPadLabels}
      targetLabel={entity.targetLabel}
      guidance={entity.guidance}
      style={fullPadStyle}
    />
  );
}

export default InputPad;
